import ConnectWalletModal from "./ConnectWalletModal";

export default ConnectWalletModal;
